package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.physical.Bus

class CombinedBuses(val id : LogicalBusId, val buses: List<Bus>) {
    val primaries = buses
        .filter { it.id.length > 7 && it.id[7].isDigit() }
        .sortedByDescending { colorRank(it.v) }
    val primary: Bus? = primaries
        .filter { it.record.ide < 4.0 }
        .firstOrNull()

    val fullName = buses.first().fullName

    override fun toString(): String {
        return id.name
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as CombinedBuses

        if (id != other.id) return false

        return true
    }

    override fun hashCode(): Int {
        return id.hashCode()
    }
}